export const getDisplayCategories = (state) =>
  Object.values(state?.displayCategories?.byId ?? [])

export const getCurrentDisplayCategory = (state, id) =>
  state?.displayCategories?.byId?.[id] ?? {}

export const getIsLoadingDisplayCategories = (state) =>
  state?.displayCategories?.isLoading ?? false

export const getDisplayCategoriesSortingMode = (state) =>
  state?.displayCategories?.categoriesSortingMode ?? false

export const getDisplayCategoriesIndexes = (state) =>
  state?.displayCategories?.categoriesIndexes ?? []

export const getDisplayCategoriesUuids = (state) =>
  getDisplayCategories(state).map(({ uuid }) => uuid)
